// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"oiWJ4wCaPxFtcxGDjZFj5"};